import React from 'react'
import Qr from "../assets/qr (1).png"
import Pattern from "../assets/pattern (2).png"

const QrCode = () => {
  return (
    <div id='qrcode' className='relative text-center px-8 md:px-16 py-20  bg-warm-yellow text-black overflow-hidden'>
      <div className='space-y-8 z-10'>

        <h1 className='text-3xl md:text-6xl font-bold'>Alternative Presale Approach</h1>
        <p className='text-sm md:text-xl md:w-2/3 mx-auto'>If you prefer not to connect your wallet to our website due to security concerns (although our website is 100% secure), you can also transfer your SOL amount directly to ELEPHONKCOIN.SOL to participate in the presale.</p>
        <div className='w-full'>
            <img src={Qr} className='w-1/2 md:w-[20%] shadow-lg mx-auto' alt="Qr Code" />
        </div>
      </div>
      <img src={Pattern} className='hidden md:block absolute top-1/2 -translate-y-1/2 left-0 -translate-x-1/2  md:h-[700px]  opacity-90 z-1' alt="" />

    </div>
  )
}

export default QrCode